import { render, staticRenderFns } from "./RemoteMonitoringQuestionnairesAdd.vue?vue&type=template&id=1afae8ec"
import script from "./RemoteMonitoringQuestionnairesAdd.vue?vue&type=script&lang=js"
export * from "./RemoteMonitoringQuestionnairesAdd.vue?vue&type=script&lang=js"
import style0 from "./RemoteMonitoringQuestionnairesAdd.vue?vue&type=style&index=0&id=1afae8ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports